'use strict';

angular.module('substoreApp.controllers')
    .controller('productchangesummaryController', ProductchangesummaryController);

function ProductchangesummaryController($scope, $routeParams, dialogData, uiservice, sessionData, productDataCollector, orderProductTermsConfirmation, htmlTruster, webtrekk) {

    $scope.isMyProductsActive = true;

    $scope.breadcrumb.init("navigation_myproducts", "#/myproducts");
    $scope.breadcrumb.add("product_change");

    $scope.progressBar.setup({ step: 2 });

    $scope.confirmation = orderProductTermsConfirmation();

    function initDialogData() {
        var data = $scope.data = dialogData;

        if (sessionData.dialogStaticData.enableWebtrekkIntegration && typeof data != 'undefined' && typeof data.newProduct != 'undefined' && typeof data.newProduct.price != 'undefined') {
            sessionData.transient.priceValue = data.newProduct.price.value;
        }

        productDataCollector.collect(data.oldProduct);
        productDataCollector.collect(data.newProduct);

        // unfortunately we do have to normalize some names from product file to simplify html template reuse
        data.newProduct.texts.emailTextProductOrder = data.newProduct.texts.emailTextProductChangeSummary;
        data.newProduct.hyperlinks.termsOrderLinkDisplayName = data.newProduct.hyperlinks.termsOrderLinkProductChangeDisplayName;
        data.newProduct.hyperlinks.termsOrderLinkUrl = data.newProduct.hyperlinks.termsOrderLinkProductChangeUrl;
        data.newProduct.hyperlinks.rescissionOrderLinkDisplayName = data.newProduct.hyperlinks.rescissionOrderLinkProductChangeDisplayName;
        data.newProduct.hyperlinks.rescissionOrderLinkUrl = data.newProduct.hyperlinks.rescissionOrderLinkProductChangeUrl;

        $scope.confirmation.customerEmail = $scope.confirmation.customerVerificationEmail = (data.newProduct.texts.emailTextProductOrder ? data.customerEmail : null);
        $scope.confirmation.emailVerification = dialogData.emailVerification;

        $scope.updateTeaser(
            data.oldProduct.texts.headerTitleProductChangeSummary,
            data.oldProduct.texts.headerSubTitleProductChangeSummary,
            data.oldProduct.images.headerImageChangeSummaryResourcePath);

        htmlTruster.trust($scope.data.newProduct);
        htmlTruster.trust($scope.data.oldProduct);

        $scope.footnotes = data.newProduct.productDescription.footnotes;

        webtrekk.track('productchange_summary', {
            page_content_id: data.invokingPortal,
            shop_product_name: data.newProduct.texts.productName,
            shop_product_quantity: 1,
            shop_product_sku: $routeParams.newSubscriptionTemplateId,
            shop_product_status: "add"
        });

    }

    // configure routing dialog functions

    $scope.nextClicked = false;

    $scope.actions = {
        next: function() {
            if ($scope.nextClicked)
                return;
            if ($scope.confirmation.failed(
                $scope.data.newProduct.hyperlinks.termsOrderLinkUrl,
                $scope.data.newProduct.hyperlinks.rescissionOrderLinkUrl,
                $scope.data.newProduct.textLists.textToBeConfirmedSummary,
                $scope.data.newProduct.textLists.textToBeConfirmedChangeSummary,
                $scope.data.newProduct.texts.emailTextProductOrder))
                return;

            $scope.nextClicked = true;

            uiservice.productChangeAction({
                    sessionId: sessionData.sessionId,
                    subscriptionTemplateId: $scope.data.oldProduct.subscriptionTemplateId,
                    uniqueSubscriptionId: $scope.data.oldProduct.subscription.uniqueSubscriptionId,
                    newSubscriptionTemplateId: $scope.data.newProduct.subscriptionTemplateId,
                    orderId: $scope.data.orderId,
                    acceptTerms: $scope.confirmation.ok.acceptTerms,
                    acceptRescissionRights: $scope.confirmation.ok.acceptRescissionRights,
                    customerEmail: $scope.confirmation.customerEmail },
                function success(response) {
                    $scope.go("/productchangeconfirmation/"+response.data.newSubscriptionTemplateId+"/"+response.data.newUniqueSubscriptionId);
                },
                $scope.throwServiceResponseFault
            );
        },
        cancel: function() {
            if ($scope.nextClicked)
                return;
            $scope.nextClicked = true;
            $scope.go("/myproducts");
        }
    };

    initDialogData();
}